import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { whenever } from '@vueuse/shared'
import { reactive } from 'vue-demi'
import { useChallengeV3 } from '../composables/challenge-v3'

interface SlotApi {
  /**
   * reCAPTCHA v3 response
   */
  response: string | undefined
  /**
   * execute reCAPTCHA v3 challenge
   */
  execute: () => Promise<string>
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChallengeV3',
  props: {
    action: {},
    as: { default: 'div' },
    autoExecute: { type: Boolean, default: true },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { response, execute } = useChallengeV3(props.action)

const slotApi: SlotApi = reactive({
  response,
  execute,
})

whenever(response, (res) => {
  emit('update:modelValue', res)
})

function onClick() {
  if (props.autoExecute) {
    execute()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.as), { onClick: onClick }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_unref(slotApi))))
    ]),
    _: 3
  }))
}
}

})